const mockMac = [
  {
    id: 1,
    img: "mac/macbookAir13m1.png",
    img2: "mac/macbookAir13m12.png",
    img3: "mac/macbookAir13m13.png",
    model: "MacBook Air 13-inch with M1 chip",
    propertisA: "MacBook Air 13-inch with M1 chip :",
    propertis1:
      "El chip Apple M1 ofrece un potente rendimiento de CPU, GPU y aprendizaje automático",
    propertis2:
      "Hasta 18 horas de duración de la batería para que pueda durar más que nunca",
    propertis3: "Pantalla Retina con colores vibrantes y detalles increíbles",
    propertis4: "El almacenamiento SSD ultrarrápido abre aplicaciones y archivos en un instante",
    propertis5: "Diseño sin ventilador para un funcionamiento silencioso",
    colors: "mac/macbookAir13m1colors.png",
  },
  {
    id: 2,
    img: "mac/macbookAir13m2.png",
    img2: "mac/macbookAir13m22.png",
    img3: "mac/macbookAir13m23.png",
    model: "MacBook Air 13/14 inch-with M2 chip",
    propertisA: "MacBook Air 13/14-inch with M2 chip :",
    propertis1:
      "Diseño sorprendentemente delgado para que pueda trabajar, jugar o crear casi cualquier cosa, en cualquier lugar",
    propertis2: "Haz más cosas más rápido con el ultrarrápido chip Apple M2",
    propertis3: "Pasa todo el día con hasta 18 horas de duración de la batería¹",
    propertis4:
      "La brillante pantalla Liquid Retina de 13,6 pulgadas cuenta con 500 nits de brillo, color amplio P3 y compatibilidad con mil millones de colores",
    propertis5:
      "Luce nítido y suena genial con una cámara FaceTime HD de 1080p, un conjunto de tres micrófonos y un sistema de sonido de cuatro bocinas con Spatial Audio",
    colors: "mac/macbookAir13m2colors.png",
  },
  {
    id: 3,
    img: "mac/macbookPro13.png",
    img2: "mac/macbookPro132.png",
    img3: "mac/macbookPro133.png",
    model: "MacBook Pro 13-inch",
    propertisA: "MacBook Pro 13-inch :",
    propertis1:
      "Haga más cosas más rápido con el chip Apple M2 de próxima generación y un sistema de enfriamiento activo que mantiene niveles profesionales de rendimiento",
    propertis2:
      "Pasa todo el día y hasta la noche con hasta 20 horas de duración de la batería",
    propertis3:
      "La pantalla Retina con 500 nits de brillo ofrece colores vibrantes y detalles increíbles",
    propertis4:
      "Dos puertos Thunderbolt le permiten conectar y alimentar accesorios de alta velocidad",
    colors: "mac/macbookPro13colors.png",
  },
  {
    id: 4,
    img: "mac/macbookPro14.png",
    img2: "mac/macbookPro142.png",
    img3: "mac/macbookPro143.png",
    model: "MacBook Pro 14/16-inch",
    propertisA: "MacBook Pro 14/16-inch :",
    propertis1:
      "M2 Pro o M2 Max, el chip más potente y eficiente jamás visto en una computadora portátil profesional, lo ayuda a asumir los proyectos más exigentes",
    propertis2:
      "Pase todo el día con hasta 18 horas de duración de la batería, gracias a la eficiencia del silicio de Apple",
    propertis3:
      "La pantalla Liquid Retina XDR es la mejor en una computadora portátil, con rango dinámico extremo, contraste increíble y colores reales",
    propertis4:
      "Mire nítido y suene claro, en cualquier lugar, con la cámara FaceTime HD de 1080p, tres micrófonos con calidad de estudio y seis altavoces con audio espacial",
    propertis5:
      "Conecte todo lo que necesita con tres puertos Thunderbolt 4, una ranura para tarjetas SDXC, un puerto HDMI y un puerto MagSafe 3",
    colors: "mac/macbookPro14colors.png",
  },
];

export default mockMac;
